import COM from "./Image";

export default COM;


// WEBPACK FOOTER //
// ./src/js/components/Image/index.js